module.exports = __webpack_public_path__ + "static/media/Scratch_After.32d52020.jpg";